import {
    GetRosterForClientQuery,
    ProcessStatusGroup,
    RosterType,
} from '__generated__/graphql'
import { type RosterListProps } from '../ClientRosterCardPreview'
import { type DetailsRowProps } from '../DetailsRow'

export const ClientVisibleProcessStatusGroups = [
    ProcessStatusGroup.Submitted,
    ProcessStatusGroup.InProcess,
    ProcessStatusGroup.OutOfProcess,
]

export function getRosterSearchPreviewProps(
    rosterData: GetRosterForClientQuery | undefined
): RosterListProps {
    return {
        details: {
            sharedRecruiters:
                rosterData?.getRosterForClient?.sharedRecruiters?.map(
                    ({ recruiter }) => ({
                        id: recruiter?.id || '',
                        preferredName: recruiter?.user?.preferredName || '',
                        profileImageKey: recruiter?.user?.profileImageKey || '',
                    })
                ) || [],
            sharedClients:
                rosterData?.getRosterForClient?.sharedClients?.map(
                    ({ client }) => ({
                        id: client?.id || '',
                        preferredName: client?.user?.preferredName || '',
                        profileImageKey: client?.user?.profileImageKey || '',
                    })
                ) || [],
            positions:
                rosterData?.getRosterForClient?.placements?.map(
                    (placement) => placement?.title?.value ?? ''
                ) || [],
            startDateLabel:
                rosterData?.getRosterForClient?.startDateLabel ?? '',
            officeLocations:
                rosterData?.getRosterForClient?.companyOffices?.map(
                    (office) =>
                        office?.companyOffice?.officeLocation?.value ?? ''
                ) || [],
            industries: rosterData?.getRosterForClient?.industries?.map(
                (industry) => industry?.industry?.value ?? ''
            ),
            sectors: rosterData?.getRosterForClient?.sectors?.map(
                (sector) => sector?.sector?.value ?? ''
            ),
            hideOnShrink: false,
        } as DetailsRowProps,
        rosterName: rosterData?.getRosterForClient?.rosterName,
        rosterId: rosterData?.getRosterForClient?.id ?? '',
        rosterType:
            rosterData?.getRosterForClient?.rosterType ?? RosterType.Search,
        statusGroupsForGraph: ClientVisibleProcessStatusGroups,
        isSelectable: false,
        showRosterType: false,
    }
}
